module.exports = __webpack_public_path__ + "static/media/ff-select-banner.ee19ed0a.png";